import React from 'react'

const PlayStoreSvg = () => (
  <svg width="149" height="44" viewBox="0 0 149 44">
    <defs>
      <rect id="a" width="149" height="43.92" rx="5" />
      <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="38.913%">
        <stop offset="0%" stopColor="#FBDA09" />
        <stop offset="100%" stopColor="#FFBC00" />
      </linearGradient>
      <path
        id="b"
        d="M11.162 3.567c.86-1.51 2.257-1.505 3.115 0l12.245 21.485c.86 1.509.137 2.732-1.586 2.732H.503c-1.735 0-2.443-1.228-1.585-2.732L11.162 3.567z"
      />
      <linearGradient id="d" x1="0%" x2="69.306%" y1="58.476%" y2="39.083%">
        <stop offset="0%" stopColor="#01E2FF" />
        <stop offset="100%" stopColor="#01C4FF" />
      </linearGradient>
      <linearGradient id="f" x1="20.281%" x2="83.82%" y1="20.102%" y2="83.621%">
        <stop offset="0%" stopColor="#28D781" />
        <stop offset="100%" stopColor="#02F076" />
      </linearGradient>
      <linearGradient id="g" x1="74.488%" x2="10.108%" y1="17.43%" y2="91.184%">
        <stop offset="0%" stopColor="#F2414E" />
        <stop offset="100%" stopColor="#E02554" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <use fill="#000" xlinkHref="#a" />
        <rect
          width="148"
          height="42.92"
          x=".5"
          y=".5"
          stroke="#A6A6A6"
          rx="5"
        />
        <rect
          width="148.5"
          height="43.42"
          x=".25"
          y=".25"
          stroke="#8F8F8F"
          strokeWidth=".5"
          rx="5"
        />
      </g>
      <g fill="#FFF">
        <path d="M78.959 14.6a3.604 3.604 0 0 1-3.607-3.6c0-1.988 1.615-3.6 3.607-3.6a3.604 3.604 0 0 1 3.607 3.6c0 1.988-1.615 3.6-3.607 3.6zm0-1.1a2.503 2.503 0 0 0 2.505-2.5c0-1.38-1.122-2.5-2.505-2.5a2.503 2.503 0 0 0-2.505 2.5c0 1.38 1.121 2.5 2.505 2.5zM54.51 11.4v2.2h2.906v.8h-4.008V7.7h4.008v.8H54.51v2.1h2.605v.8H54.51zM61.323 8.5v5.9h-1.102V8.5h-1.703v-.8h4.509v.8h-1.704zM71.143 8.5v5.9h-1.102V8.5h-1.703v-.8h4.509v.8h-1.704zM66.233 7.7h1.102v6.7h-1.102zM84.12 7.7h-.652v6.7h1.102V9.17l3.207 5.23h1.102V7.7h-1.102v4.902L84.77 7.7h-.652zM49.278 10.717h3.017l-.03.953h-2.987z" />
        <path d="M51.702 8.474c-.588-.618-1.447-.974-2.47-.974a3.535 3.535 0 0 0-3.54 3.53 3.537 3.537 0 0 0 3.54 3.53c1.989.017 3.647-1.38 3.316-3.808v-.035h-.882c.007.101.01.206.007.313.002 1.733-1 2.547-2.41 2.547a2.55 2.55 0 0 1-2.555-2.547 2.55 2.55 0 0 1 2.555-2.547c.705 0 1.317.24 1.748.68l.69-.689z" />
      </g>
      <g fill="#FFF">
        <path d="M108.218 19.7h5.68s3.27.555 3.27 4.303c0 3.748-3.27 4.303-3.27 4.303h-5.68V19.7zm1.102 2.082V26.4h3.856s1.755 0 1.755-2.31c0-2.308-1.755-2.308-1.755-2.308h-3.856z" />
        <path d="M107.717 19.7h2.004v14h-2.004zM118.338 19.7h2.004v14h-2.004zM127.77 32.699c-.552.455-1.434.882-2.828.97-3.193.198-3.195-2.71-3.195-2.906 0-.196-.157-2.567 2.383-2.944 1.798-.267 3.058.178 3.64.46v-.411c-.143-.545-.586-1.546-1.914-1.546-1.825 0-2.228.984-2.228.984l-1.669-.984s.934-1.922 3.737-1.922c3.485 0 4.078 2.399 4.078 3.207V33.696h-2.004v-.997zm-.143-2.999s-3.86-1.038-3.995 1.126c-.134 2.165 3.704 1.126 4.047-.409 0-.488-.052-.717-.052-.717zM133.535 33.169l-1.87 4.431h2.004l5.422-12.852h-2.004l-2.55 6.046-2.571-6.094h-2.004l3.573 8.469zM103.23 27.973l-6.338 2.614s.41 1.446 2.315 1.455c1.492.008 2.335-1.32 2.335-1.32l1.608 1.087s-1.298 2.095-3.955 2.095c-3.266 0-4.705-2.85-4.705-4.701 0-1.783 1.142-4.803 4.502-4.803s4.238 3.573 4.238 3.573zm-2.411-.741s-.798-1.21-2.02-.988c-2.588.473-2.262 2.732-2.262 2.732l4.282-1.744zM91.484 19.7h2.12v13.971h-2.12zM88.091 24.704l1.96.017v8.815c0 2.252-1.343 4.63-4.507 4.63-3.163 0-4.184-2.798-4.184-2.798l1.8-.755s.549 1.724 2.478 1.724c2.197 0 2.454-1.995 2.454-2.678v-.957s-.76 1.188-2.649 1.188c-2.047 0-4.48-1.75-4.48-4.735 0-2.984 2.29-4.691 4.504-4.754 1.772-.05 2.624 1.174 2.624 1.174v-.871zm-2.48 7.394c1.429 0 2.587-1.306 2.587-2.918s-1.158-2.918-2.588-2.918c-1.429 0-2.587 1.306-2.587 2.918s1.158 2.918 2.587 2.918zM75.312 33.9c-2.634 0-4.77-2.127-4.77-4.75s2.136-4.75 4.77-4.75c2.635 0 4.77 2.127 4.77 4.75s-2.135 4.75-4.77 4.75zm-.03-1.863c1.48 0 2.68-1.292 2.68-2.887s-1.2-2.887-2.68-2.887c-1.482 0-2.682 1.292-2.682 2.887s1.2 2.887 2.681 2.887zM64.992 33.9c-2.635 0-4.77-2.127-4.77-4.75s2.135-4.75 4.77-4.75c2.634 0 4.77 2.127 4.77 4.75s-2.136 4.75-4.77 4.75zm-.032-1.863c1.481 0 2.682-1.292 2.682-2.887s-1.2-2.887-2.682-2.887c-1.48 0-2.681 1.292-2.681 2.887s1.2 2.887 2.681 2.887z" />
        <g>
          <path d="M52.674 25.906h6.298l-.062 1.987h-6.236z" />
          <path d="M57.733 21.23c-1.226-1.288-3.02-2.03-5.153-2.03-4.08 0-7.389 3.294-7.389 7.358 0 4.063 3.308 7.352 7.39 7.358 4.149.037 7.61-2.877 6.917-7.936v-.074h-1.84c.015.211.02.429.015.652.005 3.614-2.086 5.309-5.03 5.309-2.945 0-5.332-2.377-5.332-5.31 0-2.931 2.387-5.308 5.332-5.308 1.473 0 2.75.502 3.648 1.417l1.442-1.435z" />
        </g>
      </g>
      <g transform="translate(10.922 6.8)">
        <mask id="e" fill="#fff">
          <use xlinkHref="#b" />
        </mask>
        <use fill="url(#c)" transform="rotate(90 12.72 15.11)" xlinkHref="#b" />
        <path
          fill="url(#d)"
          d="M0 .99l14.007 13.894L-.181 29.326z"
          mask="url(#e)"
        />
        <path
          fill="url(#f)"
          d="M-2.88-1.87l16.885 16.758 5.02-4.78z"
          mask="url(#e)"
        />
        <path
          fill="url(#g)"
          d="M14.008 14.885l7.685 7.73-22.96 7.732z"
          mask="url(#e)"
        />
      </g>
    </g>
  </svg>
)

export default PlayStoreSvg
